/*jshint esversion: 6 */
require('./modules/_tooltip.js');
require('./modules/popover.js');

class AppCore{
	constructor(settings, onBindAll){
		this.settings = settings || null;
		this.blocked = false;
		this.popOpts = {
			trigger : "manual",
			html : "true"
		};

		this.onBindAll = onBindAll || false;
	}

	resetForm(selector) {
		$(selector).find("input:text, input:password, input:file, select, textarea").val("");
		$(selector).find("input:radio, input:checkbox").removeAttr("checked").removeAttr("selected");
	}

	iniDatePicker (selector){
		let self = this;
		$(selector).on("click", function(){
			let that = this;

			if($(this).data("inline")){
				$(that).parent().append("<i class='datepicker icon icon-calendar'></i>");
			}

			var options = {
				format : $(this).data("format") ||  'Y-m-d',
				lang : $(this).data("lang") || 'es',
				timepicker : $(this).data("timepicker") || false,
				weeks : $(this).data("weeks") || false,
				inline : $(this).data("inline") || false,
				defaultDate: $(this).data("default") || false,
				defaultTime: $(this).data("default-time") || false,
				dayOfWeekStart : 1,
				closeOnDateSelect : true,
				onGenerate:function(ct, $i){
					if($(that).data("ongenerate"))
					self._runFuncByName($(that).data("ongenerate"), window, {"date":ct.dateFormat(options.format), "selector":$(this)});
				},
				onSelectDate : function(ct){
					if($(that).data("onselect"))
					self._runFuncByName($(that).data("onselect"), window, {"date":ct.dateFormat(options.format)});
				},
				onChangeMonth: function (ct) {
					if($(that).data("onchangemonth"))
					self._runFuncByName($(that).data("onchangemonth"), window, {"date":ct.dateFormat(options.format)});
				},
				onChangeYear: function (ct) {
					if($(that).data("onchangeyear"))
					self._runFuncByName($(that).data("onchangeyear"), window, {"date":ct.dateFormat(options.format)});
				},
				beforeShowDay : function(ct){
					if($(that).data("beforeshow"))
					return self._runFuncByName($(that).data("beforeshow"), window, {"date":ct.dateFormat(options.format)});
				},
				onClose: function (ct, $i){
					if($("[aria-describedby]").length) {
						$("[aria-describedby]").popover("destroy");
						$("body").unbind("click.popover");
					}
					$i.datetimepicker('destroy');
				}
			};

			$(this).datetimepicker(options).datetimepicker('show');
		});
	}

	iniTimePicker(selector){
		$(selector).on("click", function(){
			var that = this;

			if($(this).data("inline"))
			$(that).parent().append("<i class='datepicker icon icon-calendar'></i>");

			var options = {
				format : $(this).data("format") ||  'H:i',
				lang : $(this).data("lang") || 'es',
				datepicker : false,
				timepicker : true,
				weeks : $(this).data("weeks") || false,
				inline : $(this).data("inline") || false,
				step : 15,
				timepickerScrollbar : true,
				onClose: function (ct, $i){
					if($("[aria-describedby]").length) {
						$("[aria-describedby]").popover("destroy");
						$("body").unbind("click.popover");
					}
					$i.datetimepicker('destroy');
				}
			};

			$(this).datetimepicker(options);
			$(this).datetimepicker("show");
		});
	}

	iniMonthPicker(selector){
		$(selector).on("click", function(){
			var that = this;
			var options = {
				format : $(this).data("format") || 'Y-m',
				lang : $(this).data("lang") || 'es',
				inline : $(this).data("inline") || false,
				defaultDate: $(this).data("default") || false,
				timepicker : false,
				dayOfWeekStart : 1,
				onGenerate:function(ct){
					$(that).val(ct.dateFormat(options.format));
					// self.custom.datepickerStyles($(this));
					$(this).find('.xdsoft_calendar').hide();
				},
				onChangeMonth : function(ct){
					$(that).val(ct.dateFormat(options.format));
				},
				onChangeYear : function(ct){
					$(that).val(ct.dateFormat(options.format));
				},
				onClose: function (ct, $i){
					if($("[aria-describedby]").length) {
						$("[aria-describedby]").popover("destroy");
						$("body").unbind("click.popover");
					}
					$i.datetimepicker('destroy');
				}
			};

			$(this).datetimepicker(options);
			$(this).datetimepicker("show");
		});
	}

	ajaxLink(url, target, params, loader, complete, object){
		var regexp = new RegExp("'", 'g');
		var settings = {
			url : url.replace(regexp,"") || false,
			target : target ? target.replace(regexp,"") : false,
			params : params || false,
			complete : complete || false,
			loader : loader || false
		};

		this.blocked = true;

		if(settings.loader !== false){
			$(object).addClass(this.settings.loader.class);
		}

		$.ajax({
			url: settings.url,
			context: document.body,
			data: settings.params,
			success: (data, textStatus) => {
				if($("#"+settings.target)){
					if(data.search('<append>') != -1){
						$("#" + settings.target).append(data);
					} else {
						$("#" + settings.target).html(data);
					}
					this.bindAll($("#" + settings.target));
				}

				if(settings.complete !== false){
					if($.type(settings.complete) == 'function'){
						settings.complete(data);
					}
					else{
						this._runFuncByName(settings.complete, window, data);
					}
				}

				if(this.modal && this.modal.opened){
					this.modal.fitContent();
				}

				this.blocked = false;
				$(object).removeClass(this.settings.loader.class);
			},
			error: (xhr, ajaxOptions, thrownError) => {
				$(object).removeClass(this.settings.loader.class);
			}
		});
	}

	jsonLink(url, target, params, loader, complete, object){
		var regexp = new RegExp("'", 'g');
		var settings = {
			url : url.replace(regexp,"") || false,
			target : target ? target.replace(regexp,"") : false,
			params : params || false,
			complete : complete || false,
			loader : loader || false
		};

		this.blocked = true;

		if(settings.loader !== false){
			$(object).append(this.settings.loader.html);
		}

		$.ajax({
			url: settings.url,
			context: document.body,
			data: settings.params,
			dataType: "json",
			success: (data, textStatus) => {
				var target = settings.target;

				if(target){
					if($('#'+target).find("."+this.settings.feedback.class).length === 0)
					$('#'+target).append("<div class='"+this.settings.feedback["class"]+"'></div>");

					if(data.error) {
						$('#'+target).find("."+this.settings.feedback.class).removeClass(this.settings.feedback.correct_class)
						.addClass(this.settings.feedback.error_class).html(data.msg).fadeIn();

					}else{
						$('#'+target).find("."+this.settings.feedback.class).removeClass(this.settings.feedback.error_class)
						.addClass(this.settings.feedback.correct_class).html(data.msg).fadeIn();
					}
				}

				if(settings.complete){
					if($.type(settings.complete) == "function"){
						settings.complete(data);
					}
					else{
						this._runFuncByName(settings.complete, window, data);
					}
				}

				if(this.modal !== undefined && this.modal.opened){
					this.modal.fitContent();
				}

				this.blocked = false;
				$(object).find(this.settings.loader.selector).remove();
			},
			error: (xhr, ajaxOptions, thrownError) => {
				$(object).find(this.settings.loader.selector).remove();
			}
		});
	}

	ajaxForm(form, target, params, loader){
		var regexp = new RegExp("'", 'g');
		var formObj = $("#"+form);

		params = params ||  "";
		loader = loader || false;
		target = target ? target.replace(regexp,"") : false;

		if(this.blocked){
			return false;
		}

		this.blocked = true;

		if(loader){
			var submitButton = formObj.find('[type=submit]');
			submitButton.addClass(web.settings.loader.class);
		}

		$.ajax({
			url: formObj.attr("action"),
			type : formObj.attr("method"),
			data: formObj.serialize()+params,
			success: (data, textStatus) => {
				if($("#"+target)){
					$("#"+target).html(data);

					if(loader){
						formObj.find(this.settings.loader.selector).removeClass(this.settings.loader.class);
					}

					this.bindAll($("#"+target));
				}

				this.blocked = false;
			},
			error: (xhr, ajaxOptions, thrownError) => {
				if(loader){
					formObj.find(this.settings.loader.selector).removeClass(this.setting.loader.class);
				}
				this.blocked = false;
			}
		});
	}

	feedbackMsg(type, message, target){
		var obj = target || $("."+this.settings.feedback["class"]);
		switch(type){
			case "error": obj.addClass(this.settings.feedback.error_class);break;
			case "warning": obj.addClass(this.settings.feedback.warning_class);break;
			case "progress": obj.addClass(this.settings.feedback.inprogress_class);break;
			case "correct": obj.addClass(this.settings.feedback.correct_class);break;
		}
		obj.html(message).show();
	}

	inputToSelect(selector, sep=","){
		let self = this;

		$(selector).each(function(){
			if($(this).attr("value")){
				var input = $(this);
				var select = $("<select></select>");

				input.replaceWith(select);
				input.removeAttr('role');

				$.each(this.attributes, function(i, attrib){
					var name = attrib.name;
					var value = attrib.value;

					if(name === 'value') {
						var values = value.split(sep);
						$.each(values, function(i, val) {
							var opt = val.split("#");
							select.append("<option value='"+opt[0]+"'>"+opt[1]+"</option>");
						});
					}else{
						select.attr(name, value);
					}
				});

				if(input.attr("on-create")){
					self._runFuncByName(input.attr("on-create"), window, select);
				}

				if(input.attr("on-change")) {
					select.unbind("change");
					select.on('change', function () {
						self._runFuncByName(input.attr("on-change"), window, select);
					});
				}

				if(input.attr("default") !== undefined){
					select.val(input.attr("default")).change();
				}else{
					select.val(select.children("option:first").val()).change();
				}
			}
		});
	}

	bindAjaxClick(selector){
		let self = this;

		$(selector).unbind("click");
		$(selector).on("click", function(e){
			e.preventDefault();
			self.ajaxLink($(this).attr("href"), $(this).attr("target"), false, $(this).attr('loader'), $(this).attr("after-submit"), this);
		});
	}

	bindJsonClick(selector){
		let self = this;

		$(selector).unbind("click");
		$(selector).on("click", function(e){
			e.preventDefault();
			self.jsonLink($(this).attr("href"), $(this).attr("target"), false, $(this).attr('loader'), $(this).attr("after-submit"), this);
		});
	}

	bindRecursiveClick(selector){
		let self = this;

		$(selector).unbind("click");
		$(selector).on("click", function(e){
			e.preventDefault();
			self.jsonLoop(this);
		});
	}

	jsonLoop(selector){
		let self = this;
		this.jsonLink($(selector).attr("href"), $(selector).attr("target"), false, $(selector).attr('loader'), function(result){
			if(result.continue === true){
				if($(selector).attr('after-submit')){
					self._runFuncByName($(selector).attr('after-submit'), window, result);
				}

				if(!result.error){
					self.jsonLoop($(selector));
				}
			}else{
				if($(selector).attr("on-end")){
					self._runFuncByName($(selector).attr("on-end"), window, result);
				}else{
					console.log("Loop finished");
				}
			}
		}, selector);
	}

	bindLinkClick(selector){
		let self = this;

		$(selector).unbind("click");
		$(selector).on("click", function(e){
			e.preventDefault();
			self.redirect($(this).attr("href"));
		});
	}

	bindAjaxClickNL(selector){
		let self = this;

		$(selector).unbind("click");
		$(selector).on("click", function(e){
			e.preventDefault();
			self.ajaxLink($(this).attr("href"), $(this).attr("target"), false, false, $(this).attr("after-submit"), this);
		});
	}

	bindAjaxForm(selector){
		let self = this;

		$(selector).each(function(){
			var formObj = $(this);

			if(formObj.find("input[name=close]").length === 0)
			formObj.append("<input type='hidden' name='close' value='0'>");

			formObj.find("[type=submit]").each(function(){
				$(this).unbind("click");
				$(this).on("click", function(){
					switch($(this).attr("role")){
						case "save" : formObj.find("input[name=close]").val(0);break;
						case "save&exit" : formObj.find("input[name=close]").val(1);break;
					}
				});
			});

			formObj.ajaxForm({
				beforeSubmit: function(arr, $form, ops) {
					if(self.blocked){
						return false;
					}

					self.blocked = true;

					if(formObj.attr('loader')){
						formObj.find('[type=submit]').addClass(self.settings.loader.class);
					}

					if(formObj.attr("before-submit"))
					return(web._runFuncByName(formObj.attr("before-submit"), window));
					else
					formObj.addClass("sending").blur();
				},
				success: function(data, statusText, xhr, $form){
					formObj.removeClass("sending");

					if(formObj.attr("after-submit")){
						self.blocked = false;
						self._runFuncByName(formObj.attr("after-submit"), window, data);
					}

					$("#"+formObj.attr("target")).html(data);
					self.bindAll($("#"+formObj.attr("target")));

					self.blocked = false;
					formObj.find('[type=submit]').delay(0).queue(function(){
						$(this).removeClass(self.settings.loader.class).dequeue();
					});
				},
				error: function(xhr, ajaxOptions, thrownError) {
					self.blocked = false;
					formObj.removeClass("sending");
					formObj.find('[type=submit]').delay(0).queue(function(){
						$(this).removeClass(self.settings.loader.class).dequeue();
					});
				}
			});
		});
	}

	parseFeedback(jQform, data){
		let self = this;

		if(jQform.data('feedback') === undefined || jQform.data('feedback') === 'all') {
			jQform.find("." + self.settings.feedback["class"])
			.html(data.msg)
			.removeClass(data.error ? self.settings.feedback.correct_class : self.settings.feedback.error_class)
			.addClass(data.error ? self.settings.feedback.error_class : self.settings.feedback.correct_class)
			.fadeIn();
		}else if(jQform.data('feedback') === 'error'){
			if(data.error){
				jQform.find("." + self.settings.feedback["class"])
				.html(data.msg)
				.removeClass(self.settings.feedback.correct_class)
				.addClass(self.settings.feedback.error_class)
				.fadeIn();
			}else{
				jQform.find("." + self.settings.feedback.class).remove();
			}
		}else if(jQform.data('feedback') === 'success'){
			if(!data.error){
				jQform.find("." + self.settings.feedback["class"])
				.html(data.msg)
				.removeClass(self.settings.feedback.error_class)
				.addClass(self.settings.feedback.correct_class)
				.fadeIn();
			}else{
				jQform.find("." + self.settings.feedback["class"]).remove();
			}
		}
	}

	bindJsonForm(selector){
		let self = this;

		$(selector).each(function(){
			let jQform = $(this);

			if(jQform.find("input[name=close]").length === 0)
			jQform.append("<input type='hidden' name='close' value='0'>");

			jQform.find("[type=submit]").each(function(){
				$(this).unbind("click");
				$(this).on("click", function(){
					switch($(this).attr("role")){
						case "save" : jQform.find("input[name=close]").val(0);break;
						case "save&exit" : jQform.find("input[name=close]").val(1);break;
					}
				});
			});

			let submitButton = jQform.find('[type=submit]');

			jQform.ajaxForm({
				url: jQform.attr("action"),
				type: jQform.attr("method"),
				dataType: "json",
				beforeSubmit: function(arr, $form, ops) {
					if(self.blocked) return false;

					self.blocked = true;

					if(jQform.find("."+self.settings.feedback.class).length === 0)
					jQform.append("<div class='"+self.settings.feedback["class"]+"'></div>");

					if(jQform.attr("loader")){
						submitButton.addClass(self.settings.loader.class);
					}

					jQform.find("."+self.settings.forms.error_class).removeClass(self.settings.forms.error_class);
					jQform.find("."+self.settings.feedback["class"]).fadeOut("fast");

					if(jQform.attr("before-submit")){
						return(self._runFuncByName(jQform.attr("before-submit"), window));
					}
					else{
						jQform.addClass(self.settings.forms.sending_class).blur();
					}
				},
				success: function(data, textStatus){
					if(data.error){
						if(jQform.attr("after-error")){
							self.blocked = false;
							self._runFuncByName(jQform.attr("after-error"), window, data);
						}

						if(jQform.data("validator")){
							jQform.find("[name='"+data.field+"']").closest(self.settings.forms.group).addClass("has-error");

							if(data.field){
								$('html, body').animate({
									scrollTop: jQform.find("[name='"+data.field+"']").closest("input, select").offset().top-150
								}, 200);
								jQform.find("[name='"+data.field+"']").closest("input, select").focus();

								if(jQform.data("tooltip")){
									self.showToolTip(jQform, data);
								}else{
									self.parseFeedback(jQform, data);
								}
							}else{
								self.parseFeedback(jQform, data);
							}
						}else{
							self.parseFeedback(jQform, data);
						}

						if(self.modal && self.modal.opened){
							self.modal.fitContent();
						}
					}
					else{
						self.parseFeedback(jQform, data);

						if(jQform.attr("after-submit")){
							self.blocked = false;
							self._runFuncByName(jQform.attr("after-submit"), window, data);
						}

						if(data.close == 1){
							if(self.modal)
							self.modal.close();
						}
						else{
							if(self.modal && self.modal.opened)
							self.modal.fitContent();
						}
					}

					submitButton.removeClass(self.settings.loader.class);

					self.blocked = false;
				},
				error: function(xhr, ajaxOptions, thrownError, $form) {
					submitButton.remove();
					self.blocked = false;
				}
			});
		});
	}

	showToolTip(jQform, data){
		let self = this;
		$(".popover").not(jQform.find("[name='"+data.field+"']")).popover('hide');

		if(!jQform.find("[name='"+data.field+"']").is("[aria-describedby]")){
			var popSpecificOpts ={
				trigger : self.popOpts.trigger,
				placement : "top",
				html : self.popOpts.html,
				content: data.msg
			};

			jQform.find("[name='"+data.field+"']").popover(popSpecificOpts).show();
			jQform.find("[name='"+data.field+"']").popover('show');

			$("body").on("keyup.tooltip", function(event){
				event.stopPropagation();
				if (!$(event.target).is(".popover-content")) {
					$("[aria-describedby]").popover("destroy");
					$("body").unbind("click.popover");
				}
			});

			$("body").on("click.popover", function(event) {
				event.stopPropagation();
				if (!$(event.target).is(".popover-content")) {
					$("[aria-describedby]").popover("destroy");
					$("body").unbind("click.popover");
				}
			});

			$("body").unbind("click.tip");
		}
	}

	bindJsonFormSubmit(selector){
		let self = this;

		$(selector).unbind("submit");
		$(selector).on("submit", function(e){
			e.preventDefault();
			self.formJSONSubmit(selector);
		});
	}

	bindUploadForm(selector){
		let self = this;
		$(selector).each(function(){
			let form = this;
			let input = $(form).find(":file");
			let uploadButton = $(form).find("[type=button]");

			$(form).on("submit", function(){
				if(self.blocked) return false;

				self.blocked = true;

				var formData = new FormData($(form)[0]);
				var preview = $(form).data("preview") || null;
				var target = $(form).data("target") || null;

				if($(form).find("."+self.settings.feedback.class).length === 0)
				$(form).append("<div class='"+self.settings.feedbackclass+"'></div>");

				$(form).find("."+self.settings.loader.class).fadeIn("fast").show();
				$(form).find("."+self.settings.forms.error_class).removeClass(self.settings.forms.error_class);
				$(form).find("."+self.settings.feedback.class).fadeOut("fast");

				if(uploadButton){
					uploadButton.addClass(self.settings.loader.class);
				}

				$.ajax({
					url: $(form).attr("action"),
					type: "post",
					data: formData,
					dataType : 'json',
					cache: false,
					contentType: false,
					processData: false,
					xhr: function() {
						var myXhr = $.ajaxSettings.xhr();
						if(myXhr.upload)
							myXhr.upload.addEventListener("progress", that.uploadProgress, false);
						return myXhr;
					},
					success: function(data){
						if(!data.error){
							if(data.msg !== false)
							$(form).find("."+self.settings.feedback.class).html(data.msg).removeClass(self.settings.feedback.error_class).addClass(self.settings.feedback.correct_class).fadeIn();

							if(preview){
								$(preview).css({"background-image":"url("+data.data.path+")"});
							}

							if(target){
								$(target).attr("value", data.data.filename);
							}

							if($(form).attr("after-submit")){
								self.blocked = false;
								self._runFuncByName($(form).attr("after-submit"), window, data);
							}
						}
						else{
							$(form).find("."+self.settings.feedback.class).html(data.msg).removeClass(self.settings.feedback.correct_class).addClass(self.settings.feedback.error_class).fadeIn();
							input.val('');
						}

						if(uploadButton){
							$(form).find(self.settings.loader.selector).removeClass(self.settings.loader.class);
						}

						self.blocked = false;
					},
					error: function(xhr, ajaxOptions, thrownError, $form) {
						if(uploadButton){
							$(form).find(self.settings.loader.selector).removeClass(self.settings.loader.class);
						}
						self.blocked = false;
					}
				});
				return false;
			});

			uploadButton.on("click", function(){
				if(self.blocked) return false;
				$(input).trigger("click");
			});

			$(input).on("change", function(){
				if(self.blocked) return false;

				$(form).submit();
			});
		});
	}

	uploadProgress(p){
		//console.log(p);
	}

	confirm(msg){
		return(confirm(msg));
	}

	loginRequired(settings){
		if(!settings){
			settings = {transition:"bounce", forcedClose : true};
		}

		if(this.modal){
			this.modal.open(this.settings.login_required.template);
		}
	}

	bindLoginRequired(selector){
		if(this.modal){
			this.modal.bindOpen(selector, this.settings.login_required.template);
		}
	}

	bindPaginator(selector, pageContainer){
		let self = this;
		let curpag = parseInt($(selector).find("a.active").attr("pag"));
		let lastpag = parseInt($(selector).find("[name=lastpage]").val());

		$(selector).on("click", "a.link", function(e){
			e.preventDefault();

			if(!$(this).hasClass("prev") && !$(this).hasClass("next")){
				self.ajaxLink($(this).attr("href"), $(this).closest(pageContainer).attr("id"), "ipage="+$(this).attr("pag"), false, $(this).attr("after-submit"), this);
			}
			else{
				if($(this).attr("disabled") != "disabled"){
					self.ajaxLink($(this).attr("href"), $(this).closest(pageContainer).attr("id"),"ipage="+parseInt(curpag+parseInt($(this).attr("pag"))), false, $(this).attr("after-submit"), this);
				}
			}
		});

		$(selector).on("click", "a.form", function(e){
			e.preventDefault();

			if(!$(this).hasClass("prev") && !$(this).hasClass("next")){
				self.ajaxForm($(this).attr("href"), $(this).parents(pageContainer).attr("id"), "&ipage="+$(this).attr("pag"), false);
			}
			else{
				if($(this).attr("disabled") != "disabled"){
					self.ajaxForm($(this).attr("href"), $(this).parents(pageContainer).attr("id"), "&ipage="+parseInt(curpag+parseInt($(this).attr("pag"), false)));
				}
			}
		});

		if(curpag == 1){
			$(selector).find("a.prev").addClass("b-grey3").attr("disabled", "disabled").unbind('click');
		}

		if(curpag == lastpag){
			let next = $(selector).find("a.next").addClass("b-grey3").attr("disabled", "disabled");
			next.unbind('click');
		}
	}

	bindMenu(menu, option){
		let self = this;

		$(menu).find(option).unbind("click");
		$(menu).each(function(){
			var parentMenu = this;

			$(parentMenu).find(option).each(function(){
				$(this).unbind("click");
				$(this).on("click", function(e){
					e.preventDefault();
					$(parentMenu).find(option).removeClass("active");
					$(this).addClass("active");

					let loader = $(this).attr('loader') ? $(this).attr('loader') : $(parentMenu).attr('loader');

					if($(this).attr("href")){
						var target = $(this).attr("target") || $(parentMenu).attr("target");

						self.ajaxLink($(this).attr("href"), target, false, loader, $(this).attr("after-submit"), this);
					}
					else if($(this).attr("after-submit")){
						self.blocked = false;
						self._runFuncByName($(this).attr("after-submit"), window);
					}
				});
			});
		});
	}

	bindOpenTab(item){
		var self = this;
		var tabIdPool = [];

		$(item).unbind("click");
		$(item).on("click", function(){
			var targetMenu = $(this).attr("target") || false;

			if(targetMenu){
				var newTab = null;
				var newContent = null;
				var curTab = $(targetMenu).find(".active").first();
				var curContent = $("[tab-ref='"+$(curTab).attr("tab-id")+"']");
				var tabId = $(this).attr("tab-id");

				if(!tabId){
					tabId = Math.floor(Math.random() * (9999 - 1000) + 1000);

					while(tabIdPool.indexOf(tabId) != -1){
						tabId = Math.floor(Math.random() * (9999 - 1000) + 1000);
					}

					tabIdPool.push(tabId);
					$(this).attr("tab-id", tabId);
				}
				else{
					if(tabIdPool.indexOf(tabId) == -1)
					tabIdPool.push(tabId);
				}

				if($(targetMenu).find("[tab-id='"+tabId+"']").length === 0){
					// Creamos la nueva pestaña
					newTab = $(curTab.first().clone());

					newTab.attr({"tab-id": tabId, "data-href": $(this).data("href")});
					newTab.addClass("active");
					newTab.html($(this).data("tagname"));
					newTab.append("<div role='close-tab'></div>");

					if($(this).data("close-class")){
						newTab.find("[role='close-tab']").addClass($(this).data("close-class"));
						newTab.find("[role='close-tab']").on("click", function(){
							var prevTab = newTab.prev(self.settings.menu_tab.item);
							newTab.remove();
							$("[tab-ref='"+newTab.attr("tab-id")+"']").remove();
							prevTab.trigger("click");
						});
					}

					$(targetMenu).append(newTab);

					self.bindMenuTab(targetMenu, self.settings.menu_tab.item);
				}
				else{
					// La nueva pestaña ya existía
					newTab = $($(targetMenu).find("[tab-id='"+tabId+"']"));
				}

				curTab.removeClass("active");
				newTab.addClass("active");

				if($("[tab-ref='"+newTab.attr("tab-id")+"']").length === 0){
					newContent = curContent.clone();
					newContent.attr({"id": $(targetMenu).attr("target")+"-"+tabId, "tab-ref":tabId});
					curContent.parent().append(newContent);

					if(newTab.data("href")){
						self.ajaxLink($(this).data("href"), newContent.attr("id"), false, $(this).attr('loader'), false, this);
					}
				}
				else{
					newContent = $("[tab-ref='"+tabId+"']");
				}

				curContent.addClass("hide");
				newContent.removeClass("hide");
			}
		});

		$("[role='close-remote-tab']").on("click", function(){
			var targetMenu = $("[tab-id='" + $(this).data('target') + "']").parent(self.settings.menu_tab.selector);
			var prevTab = targetMenu.find(".active").prev(self.settings.menu_tab.item);
			var curTab = targetMenu.find("[tab-id='" + $(this).data('target') + "']");
			if($(this).data('target')) {
				curTab.remove();
				$("[tab-ref='" + curTab.attr("tab-id") + "']").remove();
				$(prevTab).trigger("click");
			}
		});
	}

	bindMenuTab(menu, option){
		let self = this;

		$(menu).find(option).unbind("click");
		$(menu).each(function(){
			let parentMenu = this;
			$(parentMenu).find(option).each(function(index){
				if(!$(this).attr("tab-id"))
				$(this).attr("tab-id","tab"+index);

				var tabId = $(this).attr("tab-id");

				$(this).on("click", function(e){
					$(parentMenu).find(option).removeClass('active');
					$(this).addClass('active');

					if( $(parentMenu).data("refresh")) {
						if ($(this).data("href")) {
							self.ajaxLink($(this).data("href"), tabId, false, $(this).attr('loader'), false, this);
						}
					}

					$(parentMenu).parent().find("[tab-ref]").addClass("hide");

					var menuItem = $("[tab-ref='"+tabId+"']").find("[role=menu-item].active");

					$(parentMenu).parent().find("[role=tab-nav].active").each(function(index){
						$("[tab-ref='"+$(this).attr("tab-id")+"']").removeClass("hide");
					});

					if($(menuItem).length > 0){
						self.ajaxLink($(menuItem).attr("href"), $(menuItem).parent("[role=menu]").attr('target'), false, $(this).attr('loader'), false, this);
					}
				});
			});
		});
	}

	bindDropdownMenu(button, list){
		let self = this;

		$(button).unbind("click");
		$(button).on('click',function(e){
			let element_list = $(this).parent().find(list);
			$(list).not(element_list).removeClass('hide').removeClass('show');
			$(button).find('.icon').not($(this).find('.icon')).removeClass('icon-chevron-up').addClass('icon-chevron-down');

			let position = $(this).data('position') || 'bottom';

			if(!element_list.hasClass('show') && !element_list.hasClass('hide')){
				element_list.parent().css('position', 'relative');
				element_list.attr("style", "display:auto; "+position+":0" );

				self.actionDropdown(element_list, 'show', $(this).find('.icon'));
			}else if(element_list.hasClass('show')){
				self.actionDropdown(element_list, 'hide', $(this).find('.icon'));
			}else{
				self.actionDropdown(element_list, 'show', $(this).find('.icon'));
			}

			let that = $(this);
			$('body, html').on('click.dropdown', (event) => {
				event.stopPropagation();
				if(element_list.hasClass('show')){
					if (!$(event.target).is(button)){
						self.actionDropdown(element_list, 'hide', that.find('.icon'));
						$('body, html').unbind('click.dropdown');
					}
				}
			});
		});
	}

	actionDropdown(element_list, action, icon){
		if(action === 'show'){
			element_list.removeClass('hide').addClass('show');
		}else if(action === 'hide'){
			element_list.removeClass('show').addClass('hide');
		}
	}

	bindMultipleCheckBox(selector, items_check){
		$(selector).unbind("click");
		$(selector).on("click", function(){
			if($(this).prop("checked")){
				$(items_check).prop( "checked", true );
			}
			else{
				$(items_check).prop( "checked", false );
			}
		});
	}

	redirect(url){
		if(url){
			window.location.href = url;
		}
	}

	errorHandler(){
		$(document).unbind("ajaxError");
		$(document).on("ajaxError", (e, xhr, settings, thrownError) => {
			this.blocked = false;

			if(xhr.status == 412){
				this.loginRequired();
			}

			return(false);
		});
	}

	bindConfirm(selector){
		let self = this;

		$(selector).unbind("click");
		$(selector).on("click", function(e){
			e.preventDefault();
			e.stopPropagation();

			self.createPopover(this, "confirm");
		});
	}

	bindDeleteClick(selector){
		let self = this;

		$(selector).unbind("click");
		$(selector).on("click", function(e){
			e.preventDefault();
			e.stopPropagation();

			self.createPopover(this, "delete");
		});
	}

	bindActivate(selector){
		let self = this;

		$(selector).unbind("click");

		$(selector).each(function(){
			if($(this).attr("active") == "1" && $(this).data("active")){
				if(!$(this).hasClass($(this).data('active'))){
					$(this).removeClass($(this).data("inactive")).addClass($(this).data("active"));
				}
			}
			else if($(this).attr("active") == "0" && $(this).data("inactive")){
				if(!$(this).hasClass($(this).data('inactive'))){
					$(this).removeClass($(this).data("active")).addClass($(this).data("inactive"));
				}
			}
		});

		$(selector).on("click", function(e){
			e.preventDefault();
			e.stopPropagation();
			var that = this;
			var message = "";
			if($(that).data("confirm") && $(this).data("confirm") === true){
				if($(that).attr("active") == "1")
				message = $(that).data("offmsg") || "¿Desactivar el registro?";
				else if($(that).attr("active") == "0")
				message = $(that).data("onmsg") || "¿Activar el registro?";

				self.createPopover(that,"confirm",message,function(){
					self.activate(that);
				});
			}
			else{
				self.activate(that);
			}
		});
	}

	activate(obj){
		if(this.blocked) return false;

		this.blocked = true;

		var onclass = $(obj).data("active");
		var offclass = $(obj).data("inactive");
		var arrlink = $(obj).attr("href").split("?");
		var active = $(obj).attr("active") || 0;

		$.ajax({
			url : arrlink[0],
			data : arrlink[1] ? arrlink[1]+"&active="+active : "active="+active,
			type : "post",
			dataType : "json",
			success : (res) => {
				if(!res.error){
					$(obj).popover("destroy");
					$(obj).attr("active",res.data.active);

					if(res.data.active === 0 && offclass){
						$(obj).removeClass(onclass).addClass(offclass);
					}
					else if(res.data.active == 1 && onclass){
						$(obj).removeClass(offclass).addClass(onclass);
					}

					$(obj).attr("active",res.data.active);

					if($(obj).attr("after-submit")){
						this._runFuncByName($(obj).attr("after-submit"), window, res.data);
					}
				}

				this.blocked = false;
			}
		});
	}

	createPopover(obj, type, message, callback){
		let self = this;
		$('.popover').not(obj).popover('hide');

		let pos = $(obj).data("position") || "top";
		let msg = "";

		if(!$(obj).data("message") && !message){
			switch(type){
				case "confirm": msg = "¿Confirmar acción?";break;
				case "delete": msg = "¿Eliminar registro?";break;
			}
		}
		else{
			if($(obj).data("message")){
				msg = $(obj).data("message");
			}
			else{
				msg = message;
			}
		}

		if(!$(obj).is("[aria-describedby]")){
			let popSpecificOpts = {
				trigger : this.popOpts.trigger,
				placement : pos,
				html : this.popOpts.html,
				content: msg
			};

			$(obj).popover(popSpecificOpts).show();
			$(obj).popover("show");

			$(".popover-content").append('<section role="pop-buttons"></section>');
			$(".popover-content section[role=pop-buttons]").append('<button role="popbut-yes" class="button" type="button">Sí</button><button role="popbut-no" class="button" type="button">No</button>');

			let ContentPop = $(obj).attr("aria-describedby");

			$('#'+ContentPop).on("click",'[role=popbut-yes]', function(e){
				let that = this;
				if(self.blocked) return false;

				self.blocked = true;
				$(this).addClass(self.settings.loader.class);

				if(callback && $.type(callback) == "function"){
					e.stopPropagation();
					self.blocked = false;
					self.bindAll($(obj).parent());
					$(this).removeClass(self.settings.loader.class);
					callback();
				}
				else{
					$.ajax({
						url: $(obj).attr('href'),
						context: document.body,
						method: 'GET',
						dataType: "json",
						success: function(data, textStatus){
							$(that).removeClass(self.settings.loader.class);

							if($('#'+ContentPop).find("."+self.settings.feedback.class).length === 0)
							$('#'+ContentPop+" .popover-content section").append("<div class='"+self.settings.feedback.class+"'></div>");

							if(data.error){
								$('#'+ContentPop).find("."+self.settings.feedback.class).removeClass(self.settings.feedback.correct_class)
								.addClass(self.settings.feedback.error_class).html(data.msg).fadeIn();
							}
							else{
								$('#'+ContentPop).find("."+self.settings.feedback.class).removeClass(self.settings.feedback.error_class)
								.addClass(self.settings.feedback.correct_class).html(data.msg).fadeIn();

								$('.popover button').remove();

								if($(obj).attr('close-modal') || $(obj).attr("close-modal")=='true'){
									if(self.modal){
										self.modal.close();
									}
								}

								if(($(obj).attr("remove") || $(obj).attr("remove") !== "") && type == "delete"){
									$($(obj).attr('remove')).remove();
								}

								if($(obj).attr('destroy') && $(obj).attr('destroy') == 'true'){
									$(obj).popover("destroy");
								}

								if($(obj).attr("after-submit")){
									self.blocked = false;
									self._runFuncByName($(obj).attr("after-submit"), window, data);
								}
							}

							self.blocked = false;
							self.bindAll($(obj).parent());
						},
						error: function(xhr, ajaxOptions, thrownError) {
							self.blocked = false;
							$(that).removeClass(self.settings.loader.class);
						}
					});
				}
			});

			$('#'+ContentPop).on("click","[role=popbut-no]", function(e){
				e.stopPropagation();
				$(obj).popover("destroy");
			});
		}
		else{
			$(obj).popover("destroy");
		}

		$('body, html').on('click.popover', function(event) {
			event.stopPropagation();
			var selectors = [];

			selectors.push(".popover-content");
			selectors.push(".popover-title");
			if(self.settings.confirm.selector){
				selectors.push(self.settings.confirm.selector);
			}

			if(self.settings.delete.selector){
				selectors.push(self.settings.delete.selector);
			}

			if(self.settings.activate.selector){
				selectors.push(self.settings.activate.selector);
			}

			selectors.push("[role=pop-buttons] button");

			if (!$(event.target).is(selectors.join(","))) {
				$("[aria-describedby]").popover("destroy");
				$("body").unbind('click.popover');
			}
		});
	}

	bindToggle(selector){
		let self = this;
		$(selector).unbind("click");
		$(selector).on("click", function(e){
			e.preventDefault();

			let link = $(this).attr("href") || false;
			let target = $(this).attr("target") || false;

			if(target) {
				if($(this).find(".icon").length !== 0) {
					if ($(this).find(".icon").hasClass($(this).data("closed"))) {
						$(this).find(".icon").removeClass($(this).data("closed")).addClass($(this).data("opened"));
						if (link) {
							self.ajaxLink(link, target, false, false, function () {
								$('#' + target).removeClass('collapsed');
							});
						} else {
							$('#' + target).removeClass('collapsed');
						}
					} else {
						$(this).find(".icon").removeClass($(this).data("opened")).addClass($(this).data("closed"));
						$('#' + target).addClass('collapsed');
					}
				}else{
					if ($(this).hasClass($(this).data("closed"))) {
						$(this).removeClass($(this).data("closed")).addClass($(this).data("opened"));
						if (link) {
							self.ajaxLink(link, target, false, false, function () {
								$('#' + target).removeClass('collapsed');
							});
						} else {
							$('#' + target).removeClass('collapsed');
						}
					} else {
						$(this).removeClass($(this).data("opened")).addClass($(this).data("closed"));
						$('#' + target).addClass('collapsed');
					}
				}
			}
		});
	}

	bindInputGroup(selector, type){
		let self = this;
		$(selector).each(function(){
			let group = $(this);
			let inputs = group.find('input:'+type);

			$(inputs).hide();

			$(inputs).each(function(){
				if(group.attr('default') == $(this).val()){
					$(this).prop('checked',true);
					$(this).parent().addClass('checked');
				}
				else{
					$(this).prop('checked', false);
					$(this).parent().removeClass('checked');
				}
			});

			$(inputs).on('click', function(){
				if(type == 'radio'){
					$(inputs).each(function(){
						$(this).parent().removeClass('checked');
					});

					$(this).parent().addClass('checked');
				}
				else if(type == 'checkbox'){
					if($(this).prop('checked') === true){
						$(this).parent().addClass('checked');
					}
					else{
						$(this).parent().removeClass('checked');
					}
				}
			});

			if(group.attr("on-change")){
				$(inputs).unbind('change');
				$(inputs).on('change', function(){
					self._runFuncByName(group.attr("on-change"), window, $(this));
				});
			}
		});
	}

	_runFuncByName(functionCall, context, extra){
		let args;

		if(this.settings.useEval == "true"){
			if(extra && functionCall[0] != "$"){
				args = /\b[^()]+\((.*)\).?$/.exec(functionCall);
				if (args && args[1]) {
					functionCall = functionCall.replace(/\(.*\)/, "("+args[1]+", extra)");
				}
				else{
					functionCall = functionCall.replace(/\(.*\)/,"(extra)");
				}
			}
			return eval(functionCall);
		}
		else{
			args = functionCall.match(/\(([^)]+)\)/);

			if(args !== null){
				args = args[1].split(",");
				args.forEach(function(item, i){
					args[i] = item.trim();
				});
			}
			else{
				args = [];
			}

			let functionName = functionCall.split("(");
			let namespaces = functionName[0].split(".");
			let func = namespaces.pop();

			for(let i = 0; i < namespaces.length; i++) {
				context = context[namespaces[i]];
			}

			if(extra){
				args.push(extra);
			}

			if(context[func]){
				return context[func].apply(context, args);
			}
			else{
				return false;
			}
		}
	}

	bindCaptcha(selector, key){
		let self = this;

		if(this.grecaptcha){
			$.each($(selector), function(){
				self.grecaptcha.render(this, {
					'sitekey' : key
				});
			});
		}
	}

	bindAll(context){
		context = context || document;

		this.errorHandler();
		// Links
		if(this.settings.links){
			if(this.settings.links.link){
				this.bindLinkClick($(context).find(this.settings.links.link));
			}

			if(this.settings.links.ajax){
				this.bindAjaxClick($(context).find(this.settings.links.ajax));
			}

			if(this.settings.links.json){
				this.bindJsonClick($(context).find(this.settings.links.json));
			}

			if(this.settings.links.ajax_no_loader){
				this.bindAjaxClickNL($(context).find(this.settings.links.ajax_no_loader));
			}

			if(this.settings.links.loop){
				this.bindRecursiveClick($(context).find(this.settings.links.loop));
			}
		}

		// Forms
		if(this.settings.forms){
			if(this.settings.forms.ajax){
				this.bindAjaxForm($(context).find("form"+this.settings.forms.ajax));
			}

			if(this.settings.forms.json){
				this.bindJsonForm($(context).find("form"+this.settings.forms.json));
			}

			if(this.settings.forms.upload){
				this.bindUploadForm($(context).find("form"+this.settings.forms.upload));
			}
		}

		// Paginator
		if(this.settings.paginator){
			this.bindPaginator($(context).find(this.settings.paginator.selector), this.settings.paginator.content);
		}

		// Login required
		if(this.settings.login_required){
			this.bindLoginRequired($(context).find(this.settings.login_required.selector));
		}

		// Menu
		if(this.settings.menu){
			this.bindMenu($(context).find(this.settings.menu.selector), this.settings.menu.item);
		}

		// Menu-Tab
		if(this.settings.menu_tab){
			this.bindMenuTab($(context).find(this.settings.menu_tab.selector), this.settings.menu_tab.item);
			this.bindOpenTab($(context).find(this.settings.menu_tab.tab_new));
		}

		// DatePicker
		if(this.settings.datepicker){
			this.iniDatePicker($(context).find(this.settings.datepicker.selector));
		}

		// TimePicker
		if(this.settings.timepicker){
			this.iniTimePicker($(context).find(this.settings.timepicker.selector));
		}

		// MonthPicker
		if(this.settings.monthpicker){
			this.iniMonthPicker($(context).find(this.settings.monthpicker.selector));
		}

		// Input to Select
		if(this.settings.input_to_select){
			this.inputToSelect($(context).find(this.settings.input_to_select.selector), this.settings.input_to_select.separator);
		}

		// Dropdown menu
		if(this.settings.dropdown){
			this.bindDropdownMenu($(context).find(this.settings.dropdown.selector), this.settings.dropdown.item);
		}

		// Confirm
		if(this.settings.confirm){
			this.bindConfirm($(context).find(this.settings.confirm.selector));
		}

		// Activate
		if(this.settings.activate){
			this.bindActivate($(context).find(this.settings.activate.selector));
		}

		// Delete
		if(this.settings.delete){
			this.bindDeleteClick($(context).find(this.settings.delete.selector));
		}

		//Toggle
		if(this.settings.toggle){
			this.bindToggle($(context).find(this.settings.toggle.selector));
		}

		// Check buttons group
		if(this.settings.checkboxgroup){
			this.bindInputGroup($(context).find(this.settings.checkboxgroup.selector), 'checkbox');
		}

		// Radio buttons group
		if(this.settings.radiogroup){
			this.bindInputGroup($(context).find(this.settings.radiogroup.selector),'radio');
		}

		if(this.onBindAll){
			this.onBindAll(context);
		}
	}
}

module.exports = AppCore;



// WEBPACK FOOTER //
// ./C:/wamp64/www/cig-landing/devel/js/main.js